export enum BetUpdateType {
    ExpiredFixture = 'fixture_expired',
    ChangedOdds = 'price_change'
}